import React, { useState } from "react";
import { Auth } from "aws-amplify";
import { useHistory } from "react-router-dom";
import Form from "react-bootstrap/Form";
import FormGroup from "react-bootstrap/FormGroup";
import FormControl from "react-bootstrap/FormControl";
import LoaderButton from "../components/LoaderButton";
import { useFormFields } from "../libs/hooksLib";
import { onError } from "../libs/errorLib";
import "./ChangePassword.css";

export default function ChangePassword() {
    const history = useHistory();
    const [fields, handleFieldChange] = useFormFields({
        password: "",
        oldPassword: "",
        confirmPassword: "",
    });
    const [isChanging, setIsChanging] = useState(false);

    function validateForm() {
        return (
        fields.oldPassword.length > 0 &&
        fields.password.length > 0 &&
        fields.password === fields.confirmPassword
        );
    }

    async function handleChangeClick(event) {
        event.preventDefault();

        setIsChanging(true);

        try {
            const currentUser = await Auth.currentAuthenticatedUser();
            await Auth.changePassword(
                currentUser,
                fields.oldPassword,
                fields.password
            );

            history.push("/settings");
        } catch (error) {
            onError(error);
            setIsChanging(false);
        }
    }

    return (
        <div className="ChangePassword">
        <form onSubmit={handleChangeClick}>
            <FormGroup bsSize="large" controlId="oldPassword">
            <Form.Label>Old Password</Form.Label>
            <FormControl
                type="password"
                onChange={handleFieldChange}
                value={fields.oldPassword}
            />
            </FormGroup>
            <hr />
            <FormGroup bsSize="large" controlId="password">
            <Form.Label>New Password</Form.Label>
            <FormControl
                type="password"
                onChange={handleFieldChange}
                value={fields.password}
            />
            </FormGroup>
            <FormGroup bsSize="large" controlId="confirmPassword">
            <Form.Label>Confirm Password</Form.Label>
            <FormControl
                type="password"
                onChange={handleFieldChange}
                value={fields.confirmPassword}
            />
            </FormGroup>
            <LoaderButton
                block
                type="submit"
                bsSize="large"
                disabled={!validateForm()}
                isLoading={isChanging}
            >
                Change Password
            </LoaderButton>
        </form>
        </div>
    );
}